import { HIDE_THIRD_PARTY_WIDGET } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function hideThirdPartyWidget() {
  return callingAPIMethodWithQueue(HIDE_THIRD_PARTY_WIDGET);
}